import { Routes } from '@angular/router';
import { LoginComponent } from './core/components/login/login.component';
import { ForgotUsernameComponent } from './core/components/forgot-username/forgot-username.component';
import { UaePassLoginComponent } from './core/components/uaepass-login/uaepass-login.component';
import { ForgotPasswordComponent } from './core/components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './core/components/reset-password/reset-password.component';
import { PublicLayoutComponent } from './core/components/public-layout/public-layout.component';
import { AdminLayoutComponent } from './core/components/admin-layout/admin-layout.component';
import { DashboardComponent } from './features/pages/dashboard/dashboard.component';
import { authGuard } from './core/gurads/auth.guard';
import { PaymentComponent } from './features/pages/payment/payment.component';
import { LoginCallbackComponent } from './core/components/login-callback/login-callback.component';
import { LogoutComponent } from './core/components/logout/logout.component';
import { RegisterComponent } from './core/components/register/register.component';
import { AttestationComponent } from './features/pages/services/attestation/attestation.component';
import { CertificateOfOriginComponent } from './features/pages/services/certificate-of-origin/certificate-of-origin.component';
import { CooBulkUploadComponent } from './features/pages/services/certificate-of-origin/coo-bulk-upload/coo-bulk-upload.component';
import { InformationServiceComponent } from './features/pages/services/information-service/information-service.component';
import { MembershipComponent } from './features/pages/services/membership/membership.component';
import { MediationComponent } from './features/pages/services/mediation/mediation.component';
import { AtaCarnetComponent } from './features/pages/services/ata-carnet/ata-carnet.component';
import { PreviewApplicationComponent } from './features/pages/services/ata-carnet/preview-application/preview-application.component';
import { AtaTermsConditionsComponent } from './features/pages/services/ata-carnet/ata-terms-conditions/ata-terms-conditions.component';
import { RefundComponent } from './features/pages/services/ata-carnet/refund/refund.component';
import { VenueComponent } from './features/pages/services/venue/venue.component';
import { NocLetterComponent } from './features/pages/services/ata-carnet/noc-letter/noc-letter.component';
import { AccountManagementComponent } from './features/pages/account-management/account-management.component';
import { MysteryShopperComponent } from './features/pages/services/mystery-shopper/mystery-shopper.component';
import { RoutesPath } from './shared/constants/routes-path';
import { AccessRequestDetailComponent } from './features/pages/account-management/access-request-detail/access-request-detail.component';
import { UserDetailComponent } from './features/pages/account-management/user-detail/user-detail.component';
import { AddUpdateUserComponent } from './features/pages/account-management/add-update-user/add-update-user.component';
import { MembershipDetailComponent } from './features/pages/account-management/membership-detail/membership-detail.component';
import { PlatinumBenefitsComponent } from './features/pages/account-management/platinum-benefits/platinum-benefits.component';
import { AddBusinessComponent } from './features/pages/services/add-business/add-business.component';
import { AllServicesComponent } from './features/pages/all-services/all-services.component';
import { ServiceDetailComponent } from './features/pages/all-services/service-detail/service-detail.component';
import { ApplicationsComponent } from './features/pages/applications/applications.component';
import { MediationsComponent } from './features/pages/mediations/mediations.component';
import { DocumentsComponent } from './features/pages/documents/documents.component';
import { PaymentsComponent } from './features/pages/payments/payments.component';
import { NotificationsComponent } from './features/pages/notifications/notifications.component';
import { BusinessGroupsCouncilsComponent } from './features/pages/business-groups-councils/business-groups-councils.component';
import { BusinessGroupComponent } from './features/pages/services/business-group/business-group.component';
import { ProfileComponent } from './features/pages/profile/profile.component';
import { ContactUsComponent } from './features/pages/contact-us/contact-us.component';
import { DirectoryComponent } from './features/pages/directory/directory.component';
import { FaqComponent } from './features/pages/faq/faq.component';
import { ServiceManualsComponent } from './features/pages/service-manuals/service-manuals.component';
import { VenueBookingsComponent } from './features/pages/venue-bookings/venue-bookings.component';
import { CarnetsComponent } from './features/pages/carnets/carnets.component';
import { CompleteCompanyInformationComponent } from './features/pages/account-management/membership-detail/complete-company-information/complete-company-information.component';
import { UnsavedChangesGuard } from './shared/guards/unsaved-changes.guard';
import { SuccessPageComponent } from './features/pages/services/success-page/success-page.component';
import { PaymentConfirmationComponent } from './features/pages/services/payment-confirmation/payment-confirmation.component';
import { MembershipCancellationComponent } from './features/pages/services/membership/membership-cancellation/membership-cancellation.component';
import { ManageSignatoriesComponent } from './features/pages/services/membership/manage-signatories/manage-signatories.component';
import { UnAuthorizedComponent } from './core/components/un-authorized/un-authorized.component';
import { CaseDetailComponent } from './features/pages/case-detail/case-detail.component';
import { AccessGuard } from './core/gurads/access.guard';
import { MrmAwardsTrainingWorkshopComponent } from './features/pages/services/mrm-awards-training-workshop/mrm-awards-training-workshop.component';
import { CompanyAdditionalInformationComponent } from './features/pages/services/company-additional-information/company-additional-information.component';
import { StaticsComponent } from './features/pages/statics/statics.component';
import { VenueDetailComponent } from './features/pages/services/venue/venue-detail/venue-detail.component';
import { ChamberEntrepreneurshipComponent } from './features/pages/services/chamber-entrepreneurship/chamber-entrepreneurship.component';

export const routes: Routes = [
    {
        path: '',
        component: PublicLayoutComponent,
        children: [
            {
                path: '',
                redirectTo: RoutesPath.PUBLIC.LOGIN,
                pathMatch: "full"
            },
            {
                path: RoutesPath.PUBLIC.LOGIN,
                component: LoginComponent
            },
            {
                path: RoutesPath.PUBLIC.FORGOT_USERNAME,
                component: ForgotUsernameComponent
            },
            {
                path: RoutesPath.PUBLIC.FORGOT_PASSWORD,
                component: ForgotPasswordComponent
            },
            {
                path: RoutesPath.PUBLIC.RESET_PASSWORD,
                component: ResetPasswordComponent
            },
            {
                path: RoutesPath.PUBLIC.UAEPASS_LOGIN,
                component: UaePassLoginComponent
            },
            {
                path: RoutesPath.PUBLIC.REGISTER,
                component: RegisterComponent
            },
            {
                path: RoutesPath.PUBLIC.LOGIN_CALLBACK,
                component: LoginCallbackComponent
            },
            {
                path: RoutesPath.PUBLIC.LOGOUT_CALLBACK,
                component: LogoutComponent
            },
            {
                path: RoutesPath.PAYMENT_CONFIRMATION,
                component: PaymentConfirmationComponent,
                data: { type: 'standalone' }
            },
            {
                path: RoutesPath.PUBLIC.MEDIATION_CASE,
                component: CaseDetailComponent
            },
            // {
            //     path: `${RoutesPath.PUBLIC.CASE_DETAIL}/:sr`,
            //     component: CaseDetailComponent
            // },
            {
                path: `${RoutesPath.PUBLIC.MEDIATION_CASE_DETAIL}`,
                component: CaseDetailComponent,
                data: { type: 'guest' }
            }
        ],
    },
    {
        path: '',
        component: AdminLayoutComponent,
        canActivate: [authGuard],
        children: [
            {
                path: RoutesPath.DASHBOARD,
                component: DashboardComponent,
                canActivate: [authGuard],
                // data: { breadcrumb: 'DASHBOARD' },
            },
            {
                path: RoutesPath.SERVICES_LIST,
                component: AllServicesComponent,
                canActivate: [authGuard],
                data: { breadcrumb: 'SERVICES' },
            },

            {
                path: RoutesPath.ACCOUNT_MANAGEMENT,
                component: AccountManagementComponent,
                canActivate: [authGuard],
                // data: { breadcrumb: 'SERVICES' },
            },
            {
                path: RoutesPath.MEMBERSHIP.DETAIL + "/:csn",
                component: MembershipDetailComponent,
                canActivate: [authGuard],
                // data: { breadcrumb: 'SERVICES' },
            },
            {
                path: RoutesPath.ACCESS_REQUEST_DETAIL + "/:csn/:sr_no",
                component: AccessRequestDetailComponent,
                canActivate: [authGuard],
                // data: { breadcrumb: 'SERVICES' },
            },
            {
                path: RoutesPath.USER_DETAIL + "/:csn/:userId",
                component: UserDetailComponent,
                canActivate: [authGuard],
                data: { breadcrumb: 'USER_DETAIL' },
            },
            {
                path: RoutesPath.PLATINUM_MEMBERSHIP_BENEFITS,
                component: PlatinumBenefitsComponent,
                canActivate: [authGuard],
                // data: { breadcrumb: 'SERVICES' },
            },
            {
                path: RoutesPath.SERVICE_DETAIL + '/:id',
                component: ServiceDetailComponent,
                canActivate: [authGuard],
                data: { breadcrumb: 'SERVICES' },
            }, {
                path: RoutesPath.APPLICATIONS,
                component: ApplicationsComponent,
                canActivate: [authGuard],
                // data: { breadcrumb: 'SERVICES' },
            },
            {
                path: RoutesPath.MEDIATION,
                component: MediationsComponent,
                canActivate: [authGuard],
                // data: { breadcrumb: 'SERVICES' },
            },
            {
                path: RoutesPath.DOCUMENTS,
                component: DocumentsComponent,
                canActivate: [authGuard],
                // data: { breadcrumb: 'SERVICES' },
            },
            {
                path: RoutesPath.PAYMENTS,
                component: PaymentsComponent,
                canActivate: [authGuard],
                // data: { breadcrumb: 'SERVICES' },
            },
            {
                path: RoutesPath.STATEMENTS,
                component: PaymentsComponent,
                canActivate: [authGuard],
                data: { type: 'statements' }
            },
            {
                path: RoutesPath.NOTIFICATIONS,
                component: NotificationsComponent,
                canActivate: [authGuard],
                data: { breadcrumb: 'NOTIFICATIONS' },
            },
            {
                path: RoutesPath.BUSINESS_GROUPS_COUNCILS,
                component: BusinessGroupsCouncilsComponent,
                canActivate: [authGuard],
                // data: { breadcrumb: 'SERVICES' },
            },
            {
                path: RoutesPath.BUSINESS_GROUP,
                component: BusinessGroupComponent,
                data: { breadcrumb: 'BUSINESS_GROUP' },
                canActivate: [authGuard],
                // This method is used to load children
                loadChildren: () => import('./features/pages/services/business-group/business-group.routes').then(m => m.businessGroupRoutes)

            },
            {
                path: RoutesPath.PROFILE,
                component: ProfileComponent,
                canActivate: [authGuard],
                data: { breadcrumb: 'PROFILE' },
            },
            {
                path: RoutesPath.CONTACT_US,
                component: ContactUsComponent,
                canActivate: [authGuard],
                data: { breadcrumb: 'CONTACT_US' },
            },
            {
                path: RoutesPath.FAQ,
                component: FaqComponent,
                canActivate: [authGuard],
                data: { breadcrumb: 'FAQ' },
            },
            {
                path: RoutesPath.DIRECTORY,
                component: DirectoryComponent,
                canActivate: [authGuard],
                data: { breadcrumb: 'DIRECTORY' },
            },
            {
                path: RoutesPath.SERVICE_MANUALS,
                component: ServiceManualsComponent,
                canActivate: [authGuard],
                data: { breadcrumb: 'RESOURCES' },
            },
            {
                path: RoutesPath.VENUES,
                component: VenueBookingsComponent,
                canActivate: [authGuard],
                // data: { breadcrumb: 'SERVICES' },
            },
            {
                path: RoutesPath.ATA_CARNET,
                component: CarnetsComponent,
                canActivate: [authGuard],
                // data: { breadcrumb: 'SERVICES' },
            },
            {
                path: RoutesPath.MEMBERSHIP.COMPLETE_COMPANY_INFORMATION,
                component: CompleteCompanyInformationComponent,
                canActivate: [authGuard],
                // data: { breadcrumb: 'SERVICES' },
            },
            {
                path: RoutesPath.STATICS,
                component: StaticsComponent,
                canActivate: [authGuard],
                data: { breadcrumb: 'STATICS' },
            }
        ],
    },
    {
        path: RoutesPath.SERVICE,
        // component: PublicLayoutComponent,
        component: AdminLayoutComponent,
        canActivate: [authGuard],
        children: [
            {
                path: RoutesPath.MEMBERSHIP.REGISTRATION,
                component: MembershipComponent,
                canActivate: [authGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { type: 'registration' }
            },
            {
                path: RoutesPath.MEMBERSHIP.REGISTRATION + "/:sr_no",
                component: MembershipComponent,
                canActivate: [authGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { type: 'registration' }
            },
            {
                path: RoutesPath.MEMBERSHIP.CANCELLATION,
                component: MembershipCancellationComponent,
                canActivate: [authGuard, AccessGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { type: 'cancellation' }
            },
            {
                path: RoutesPath.MEMBERSHIP.CANCELLATION + "/:sr_no",
                component: MembershipCancellationComponent,
                canActivate: [authGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { type: 'cancellation' }
            },
            {
                path: RoutesPath.MEMBERSHIP.AMENDMENT,
                component: MembershipComponent,
                canActivate: [authGuard, AccessGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { type: 'amendment' }
            },
            {
                path: RoutesPath.MEMBERSHIP.AMENDMENT + "/:sr_no",
                component: MembershipComponent,
                canActivate: [authGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { type: 'amendment' }
            },
            {
                path: RoutesPath.MEMBERSHIP.RENEW + "/:sr_no",
                component: MembershipComponent,
                canActivate: [authGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { type: 'renew' }
            },
            {
                path: RoutesPath.MEMBERSHIP.RENEW,
                component: MembershipComponent,
                canActivate: [authGuard, AccessGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { type: 'renew' }
            },
            {
                path: RoutesPath.MEMBERSHIP.MANAGE_SIGNATORIES,
                component: ManageSignatoriesComponent,
                canActivate: [authGuard, AccessGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { type: 'signatories' }
            },
            {
                path: RoutesPath.MEMBERSHIP.MANAGE_SIGNATORIES + "/:sr_no",
                component: ManageSignatoriesComponent,
                canActivate: [authGuard],
                canDeactivate: [UnsavedChangesGuard],
                data: { type: 'signatories' }
            },
            {
                path: RoutesPath.SUCCESS_PAGE + "/:sr_no",
                component: SuccessPageComponent,
                canActivate: [authGuard],
            },
            {
                path: RoutesPath.PAYMENT_CONFIRMATION,
                component: PaymentConfirmationComponent,
                canActivate: [authGuard],
            },
            {
                path: RoutesPath.BUSINESS_GROUP,
                canActivate: [authGuard],
                // This method is used to load children
                loadChildren: () =>
                    import('./features/pages/services/business-group/business-group.routes')
                        .then(m => m.businessGroupFormRoutes)
            },
            {
                path: RoutesPath.INFORMATION_SERVICE,
                component: InformationServiceComponent,
                canActivate: [authGuard, AccessGuard],
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.INFORMATION_SERVICE + "/:sr_no",
                component: InformationServiceComponent,
                canActivate: [authGuard, AccessGuard],
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.PAYMENT + "/:sr_no",
                component: PaymentComponent,
                canActivate: [authGuard],
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.PAYMENT,
                component: PaymentComponent,
                canActivate: [authGuard],
                canDeactivate: [UnsavedChangesGuard],
            },
            //ATTESTATION services routes
            {
                path: RoutesPath.ATTESTATION.AUTHENTICATE,
                component: AttestationComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'authenticate-document' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.ATTESTATION.CERTIFY,
                component: AttestationComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'certify-document' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.ATTESTATION.VERIFY_SIGNATURE,
                component: AttestationComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'verify-signature' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.ATTESTATION.AUTHENTICATE + "/:sr_no",
                component: AttestationComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'authenticate-document' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.ATTESTATION.AUTHENTICATE + "/:sr_no/:csn",
                component: AttestationComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'authenticate-document' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.ATTESTATION.CERTIFY + "/:sr_no",
                component: AttestationComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'certify-document' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.ATTESTATION.CERTIFY + "/:sr_no/:csn",
                component: AttestationComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'certify-document' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.ATTESTATION.VERIFY_SIGNATURE + "/:sr_no",
                component: AttestationComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'verify-signature' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.ATTESTATION.VERIFY_SIGNATURE + "/:sr_no/:csn",
                component: AttestationComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'verify-signature' },
                canDeactivate: [UnsavedChangesGuard],
            },

            {
                path: RoutesPath.COO.ISSUE,
                component: CertificateOfOriginComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'issue-coo' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.COO.ISSUE + "/:sr_no",
                component: CertificateOfOriginComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'issue-coo' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.COO.ISSUE + "/:sr_no/:csn",
                component: CertificateOfOriginComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'issue-coo' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.COO.AMENDMENT,
                component: CertificateOfOriginComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'amendment-coo' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.COO.AMENDMENT + "/:sr_no",
                component: CertificateOfOriginComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'amendment-coo' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.COO.AMENDMENT + "/:sr_no/:csn",
                component: CertificateOfOriginComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'amendment-coo' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.COO.PERSONAL,
                component: CertificateOfOriginComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'personal' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.COO.PERSONAL + "/:sr_no",
                component: CertificateOfOriginComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'personal' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.COO.PERSONAL + "/:sr_no/:csn",
                component: CertificateOfOriginComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'personal' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.COO.BULK_UPLOAD,
                component: CooBulkUploadComponent,
                canActivate: [authGuard, AccessGuard],
            },
            {
                path: RoutesPath.COO.GSP_CERTIFICATE,
                component: CertificateOfOriginComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'gsp-certificate' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.COO.GSP_CERTIFICATE + "/:sr_no",
                component: CertificateOfOriginComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'gsp-certificate' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.COO.GSP_CERTIFICATE + "/:sr_no/:csn",
                component: CertificateOfOriginComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'gsp-certificate' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.MEDIATION,
                component: MediationComponent,
                canActivate: [authGuard, AccessGuard],
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.MEDIATION + "/:sr_no",
                component: MediationComponent,
                canActivate: [authGuard, AccessGuard],
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.ATA.CARNET,
                component: AtaCarnetComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'new' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.ATA.CARNET + "/:sr_no",
                component: AtaCarnetComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'new' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.ATA.CARNET + "/:sr_no/:csn",
                component: AtaCarnetComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'new' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.ATA.AMENDMENT,
                component: AtaCarnetComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'amendment' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.ATA.AMENDMENT + "/:sr_no",
                component: AtaCarnetComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'amendment' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.ATA.AMENDMENT + "/:sr_no/:csn",
                component: AtaCarnetComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'amendment' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.ATA.REFUND,
                component: RefundComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'refund' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.ATA.REFUND + "/:sr_no",
                component: RefundComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'refund' }
            },
            {
                path: RoutesPath.ATA.REFUND + "/:sr_no/:csn",
                component: RefundComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'refund' }
            },
            {
                path: RoutesPath.ATA.NOC_LETTER,
                component: NocLetterComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'noc' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.ATA.NOC_LETTER + "/:sr_no",
                component: NocLetterComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'noc' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.ATA.NOC_LETTER + "/:sr_no/:csn",
                component: NocLetterComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'noc' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.ATA.SUBSTITUTE,
                component: AtaCarnetComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'substitute' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.ATA.SUBSTITUTE + "/:sr_no",
                component: AtaCarnetComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'substitute' }
            },
            {
                path: RoutesPath.ATA.SUBSTITUTE + "/:sr_no/:csn",
                component: AtaCarnetComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'substitute' }
            },
            {
                path: RoutesPath.ATA.REPLACE,
                component: AtaCarnetComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'replace' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.ATA.REPLACE + "/:sr_no",
                component: AtaCarnetComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'replace' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.ATA.REPLACE + "/:sr_no/:csn",
                component: AtaCarnetComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'replace' },
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.ATA.CANCEL,
                component: AtaCarnetComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'cancel' }
            },
            {
                path: RoutesPath.ATA.CANCEL + "/:sr_no",
                component: AtaCarnetComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'cancel' }
            },
            {
                path: RoutesPath.ATA.CANCEL + "/:sr_no/:csn",
                component: AtaCarnetComponent,
                canActivate: [authGuard, AccessGuard],
                data: { mode: 'cancel' }
            },
            {
                path: RoutesPath.ATA.PREVIEW,
                component: PreviewApplicationComponent,
                canActivate: [authGuard, AccessGuard],
            },
            {
                path: RoutesPath.ATA.TERMS,
                component: AtaTermsConditionsComponent,
                canActivate: [authGuard, AccessGuard],
            },

            {
                path: RoutesPath.VENUE.VENUE_LIST,
                component: VenueComponent,
                canActivate: [authGuard],
            },
            {
                path: RoutesPath.VENUE.BOOKING_DETAIL + "/:sr_no/:csn",
                component: VenueComponent,
                canActivate: [authGuard],
            },
            {
                path: RoutesPath.VENUE.DETAILS + "/:id",
                component: VenueDetailComponent,
                canActivate: [authGuard],
            },
            {
                path: RoutesPath.VENUE.DETAILS,
                component: VenueComponent,
                canActivate: [authGuard],
            },            
            {
                path: RoutesPath.ADD_USER + "/:csn",
                component: AddUpdateUserComponent,
                canActivate: [authGuard],
                data: { type: 'add' }
            },
            {
                path: RoutesPath.UPDATE_USER + "/:csn/:userId",
                component: AddUpdateUserComponent,
                canActivate: [authGuard],
                data: { type: 'update' }
            },
            {
                path: RoutesPath.ADD_MORE_BUSINESS,
                component: AddBusinessComponent,
                canActivate: [authGuard],
            },
            {
                path: RoutesPath.ADD_MORE_BUSINESS + "/:sr_no",
                component: AddBusinessComponent,
                canActivate: [authGuard],
            },
            {
                path: RoutesPath.PUBLIC.MEDIATION_CASE_DETAIL,
                component: CaseDetailComponent,
                canActivate: [authGuard],
                data: { type: 'after-login' }
            },
            {
                path: RoutesPath.MYSTERY_SHOPPER,
                component: MysteryShopperComponent,
                canActivate: [authGuard, AccessGuard],
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.MYSTERY_SHOPPER + "/:sr_no",
                component: MysteryShopperComponent,
                canActivate: [authGuard, AccessGuard],
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.MRM_AWARDS,
                component: MrmAwardsTrainingWorkshopComponent,
                data: { mode: 'mrm-award' },
                canActivate: [authGuard, AccessGuard],
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.MRM_AWARDS + "/:sr_no",
                component: MrmAwardsTrainingWorkshopComponent,
                data: { mode: 'mrm-award' },
                canActivate: [authGuard, AccessGuard],
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.MRM_TRAINING_WORKSHOP,
                component: MrmAwardsTrainingWorkshopComponent,
                data: { mode: 'training-workshop' },
                canActivate: [authGuard, AccessGuard],
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.MRM_TRAINING_WORKSHOP + "/:sr_no",
                component: MrmAwardsTrainingWorkshopComponent,
                data: { mode: 'training-workshop' },
                canActivate: [authGuard, AccessGuard],
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.COMPANY_INFORMATION,
                component: CompanyAdditionalInformationComponent,
                data: { type: 'company-information' },
                canActivate: [authGuard, AccessGuard],
                canDeactivate: [UnsavedChangesGuard],
            },
            {
                path: RoutesPath.CHAMBER_ENTREPRENEURS,
                component: ChamberEntrepreneurshipComponent,
                data: { type: 'chamber-entrepreneur' },
                canActivate: [authGuard, AccessGuard],
                canDeactivate: [UnsavedChangesGuard],
                // data: { breadcrumb: 'CHAMBER_ENTREPRENEURS' },
            },
            {
                path: RoutesPath.CHAMBER_ENTREPRENEURS + "/:sr_no",
                component: ChamberEntrepreneurshipComponent,
                data: { type: 'chamber-entrepreneur' },
                canActivate: [authGuard, AccessGuard],
                canDeactivate: [UnsavedChangesGuard],
                // data: { breadcrumb: 'CHAMBER_ENTREPRENEURS' },
            }
        ]
    },
    { path: 'unauthorized', component: UnAuthorizedComponent },
    { path: '**', redirectTo: 'unauthorized' } // optional
];

